/**
 * @generated SignedSource<<438c8ccf5af2466a576ed050d799fe88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionContributors_softwareReleasesLaunchCard$data = ReadonlyArray<{
  readonly node: {
    readonly extendedProfile?: {
      readonly jobTitle: string | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly picture: AGG$URL;
  };
  readonly " $fragmentType": "versionContributors_softwareReleasesLaunchCard";
}>;
export type versionContributors_softwareReleasesLaunchCard$key = ReadonlyArray<{
  readonly " $data"?: versionContributors_softwareReleasesLaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionContributors_softwareReleasesLaunchCard">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "versionContributors_softwareReleasesLaunchCard",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "picture"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jobTitle"
                  }
                ]
              }
            ],
            "type": "AtlassianAccountUser"
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraVersionContributorEdge"
};

(node as any).hash = "48615e9b01f03fa862341197581c3df7";

export default node;
